export class FeCmsNotificationCookie {
    private readonly className: string;

    constructor(className: string) {
        this.className = className;
    }

    public setDisableHintCookie(): void {
        let exdate = new Date();
        exdate.setDate(exdate.getDate() + 365);

        document.cookie = 'NotificationSeen_' + this.className + '=true;path=/;expires=' + exdate.toUTCString();
    }
}
